// extracted by mini-css-extract-plugin
module.exports = {"root":"Content__root--2D5f1"};